export default {
  generic: {
    welcome: 'Welcome',
    login: 'Login',
    support: 'Support',
    logout: 'Logout',
    viewAll: 'View All',
    loading: 'Loading...',
    viewAllJobs: 'All jobs',
    openFacebook: 'Get help from Facebook Page',
    openMessenger: 'Write as via Facebook Messager',
    openEmail: 'Write us',
    accept: 'Accept',
    postCode: 'PostCode',
    city: 'City',
    street: 'Street',
    streetNumber: 'Street number',
    cancel: 'Cancel',
    save: 'Save',
    OK: 'OK',
    hour: 'hour',
    add: 'Add new',
    location: 'Location',
    previous: 'Previous',
    hourly: 'Hourly',
    monthly: 'Monthly',
    noData: 'No data at the moment',
    yes: 'Yes',
    no: 'No',
    backToLogin: 'Back to login',
    backToHome: 'Back to the homepage',
    net: 'Net',
    back: 'Back',
    register: 'Registration',
    male: 'Male',
    female: 'Female',
    decline: 'Decline',
    loginUpsell: 'Young, flexible and dynamic workforce at your fingertips',
    month: 'month',
    sign: 'Sign',
    studetnOrg: 'HelloStudent Student Organization',
    noti: 'Notification',
    look: 'Look',
    notFound: 'Page not found',
    open: 'Open',
    search: 'Search',
    filterPlaceholder: 'Filter...',
    includeAll: 'Include all',
  },
  menu: {
    home: 'Home',
    jobs: 'Jobs',
    notifications: 'Notifications',
    profile: 'Profile',
    support: 'Support',
    management: 'Management',
    students: {
      collapse: 'Students',
      invited: 'Invited students',
      available: 'Available students',
    },
  },
  jobPage: {
    data: 'Details',
    workForce: 'Workforce',
    activeJobs: 'Active jobs',
    inactiveJobs: 'Inactive jobs',
    title: 'Have a look at our students',
    activeWorkers: 'Active workers',
    applicants: 'Applicants',
    invited: 'Invited workers',
    cta: 'Create a job in order to be able to be able to employ them',
    jobDetailPageTitle: 'Job Details:',
    createRole: 'Create role',
    createJob1: 'Create job 1',
    createJob: 'Create job',
    selectJobType: 'Select job type',
    manualJobCreation: 'Create job manually',
    createJobFromUrl: 'Create job from URL',
    importFromFeed: 'Import from XML feed',
    useImportedJobs: 'Use imported jobs',
    loadingFromUrl: 'Loading job details from URL...',
    hungarianLanguage: 'Hungarian language',
    englishLanguage: 'English language',
    createRoleHelper: 'In order to create a Job, create a role first',
    noJobsYet: 'Your job list is empty, create new job.',
    hoursPerMonth: 'Hours/week',
    worker: 'Worker',
    workers: 'Workers',
    expectedWorkingHours: 'Expected working hours',
    financialDetails: 'Financial details',
    terminateJob: 'Close job',
    languageHasBeenRemoved: 'The selected language has been successfully removed',
    languageRemovalFailed: 'Failed to remove the selected language',
    removeLanguage: 'Remove language',
    removeLanguageAlertTitle: 'Do you want to remove one of the languages?',
    removeLanguageAlertBody:
      'The job will be deleted in the selected language, and only the version available in the remaining language will be kept.',
    editJob: 'Edit job',
    generateFacebookPost: 'Facebook AI Post Generation',
    workerInvitationRollback: 'Cancel application',
    terminatedJobInfo: 'This job cannot be edited, it already has been closed',
    jobHasBeenTerminated: 'Job is successfully terminated',
    jobTerminationFailed: 'Job termination is failed',
    terminateJobAlertTitle: 'Would you like to terminate the job?',
    terminateJobAlertBody:
      'We will rollback the applications and we will create their confirmation',
    feedDialog: {
      title: 'Import from XML feed',
      description: 'Enter the XML feed URL and we will load all job listings from it.',
      placeholder: 'https://example.com/feed.xml',
      errorEmpty: 'Please enter a URL',
      errorInvalid: 'Please enter a valid URL (https://...) that points to an XML feed',
      cancel: 'Cancel',
      loadFeed: 'Load feed',
      foundJobs: '{{count}} jobs found',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      untitledJob: 'Untitled job',
      importSelected: 'Import ({{count}})',
      importingProgress: 'Job {{current}} of {{total}}',
      deleteImportedJobs: 'Delete imported jobs',
      fetchSuccess: '{{count}} jobs successfully loaded from the XML feed',
      fetchError: 'Failed to load the XML feed. Please check the URL and try again.',
      clearCacheSuccess: 'Imported jobs have been successfully deleted.',
      clearCacheError: 'Failed to delete imported jobs. Please try again.',
    },
    jobDetails: {
      title: 'Job Details',
      englishTab: 'English language',
      hungarianTab: 'Hungarian language',
    },
    removeWorkersFromJobDialog: {
      title: 'Cancel application',
      helperText: 'You can select one or more worker to cancel their application',
      selectedWorkers: 'Selected worker: {{number}}',
      quitWorkerFromJob: 'Cancel for {{number}} worker',
      teminateWorkerFailed: 'Worker cancelation failed.',
      handleJobApplicationSuccess: 'Worker application was processed successfully',
      handleJobApplicationFailed: 'Failed to process worker application',
    },
    createJobForm: {
      hourlyWage: 'Hourly Wage',
      hourlyNetAmount: 'Hourly net amount: {{amount}}',
      hourlyComission: 'Cost of the student organisation: {{amount}}',
      hourlyGrossWage: 'Hourly gross amount: {{amount}}',
      hourlyPersonalTax: 'Hourly personal tax: {{amount}}',
      hourlyAmountToReceive: 'Hourly net amount student receives: {{amount}}',
      hourlyAmountYouPay: 'Hourly amount you pay: ',
      totalNetAmount: 'Monthly net amount: {{amount}}',
      totalComission: 'Monthly of the student organisation: {{amount}}',
      totalGrossWage: 'Monthly gross amount: {{amount}}',
      totalPersonalTax: 'Total personal tax: {{amount}}',
      totalAmountToReceive: 'Total amount student receives: {{amount}}',
      selectRoleTemplate: 'Select role template',
      newRole: 'New role',
      buttonLabel: 'Create job',
      netWage: 'Net wage',
      personalTax: 'Personal tax',
      grossWage: 'Gross wage',
      comission: 'Comission',
      amountYouPay: 'Amount you pay',
      confirm: 'Confirm',
      inviteTitle: 'Select workers to invite',
      selectedWorkers: 'Selected workers count: ',
      confirmTitle: 'Confirm job details',
      success: 'Job has been created successfully',
      inviteAfterActivation: 'Offers will be sent after activation.',
      error: 'There was an error while creating job',
      editSuccess: 'Job has been updated successfully',
      editError: 'There was an error while updating job',
      confirmCloseTitle: 'Are you sure you want to exit?',
      confirmCLoseText: 'Your changes will not be saved.',
      editButtonLabel: 'Edit job',
      longTermJob: 'Long term job',
      shortTermJob: 'Short term job',
      timeSchedule: 'How many hours needed? Which days? When?',
      workerCount: 'How many workers needed? (You can modify later)',
      startNow: 'Job starts immediately',
      girlsAndBoys: 'We accept applications from both girls and boys',
      girls: 'We accept applications from girls.',
      boys: 'We accept applications from boys',
      language: 'Language skills',
      hungarianSkills: 'Hungarian language skills needed',
      drivingLicense: 'Driving license needed?',
      documents: 'Which documents are needed to do the job?',
      documentsPlaceholder: 'e.g. Health booklet, lung filter',
      extraSkills: 'Skills, experience and other requirements',
      noLicense: 'Not needed',
      car: 'Car',
      motorCycle: 'Motorcycle',
      englishSkills: 'English language skills needed',
      bonus: 'Bonus for the students',
      bonusPlaceholder: 'eg. Free transfer, free meals or housing',
      contactPerson: 'Contact name',
      contactPhone: 'Phonenumber',
      contactEmail: 'Email',
      equipmentInfo: 'How should the worker arrive?',
      equimentInfoPlaceHolder:
        'eg. Wear white shirts. We wxpect you to arrive 15 mins before the shift',
      arriveInfo: 'Who and where should the student be looking for',
      arrivePlaceholder:
        'eg. Look for John Smith at the reception and ask for an entry to the office number 106.',
      under25: 'Expenses in case of a student below 25 years old',
      over25: 'Expenses in case of a student above 25 years old',
      breakAlert:
        '* Amennyiben a feladatteljesítés tartama a napi hat órát meghaladja, napi húsz, ha a napi kilenc órát meghaladja, további napi huszonöt perc munkaközi szünetet kell biztosítani. Az iskolaszövetkezet nappali tagozatos tanuló részére, ha két egymást követő napon végzi feladatát, a napi munka befejezése és a következő napi munka megkezdése között legalább tizenegy óra napi pihenőidőt kell biztosítani.',
      breakAlertTitle: 'A munkatörvény által előírt kötelező szünet a diákok számára.',
      isInterviewNeeded: 'Should we make a video interview with the students? (no additional fee)',
      editInterviewQuestions: 'Edit interview questions',
      incorrectWage: 'Incorrect gross wage amount',
      contact: {
        info: 'Would you like more information about this job?',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
      },
      interviewQuestionsDialog: {
        title: 'Interview questions',
        questionHeading: 'Question {{number}}: {{question}}',
        question: 'Question',
        partDuration: 'Part duration (sec)',
        numOfRetakes: 'Retakes',
        useDefault: 'Use default questions',
        defaultTooltip: 'Use questions provided by the admin',
        addQuestion: 'Add question',
        description: 'Description',
        explanation: 'Explanation',
        conclusion: 'Conclusion',
        points: 'Points',
      },
    },
    createJobModal: {
      title: 'Do you want to create the below job?',
      jobTitle: 'Job title: {{jobTitle}}',
      jobDescription: 'Job description: {{jobDescription}}',
      jobLocation: 'Job location: {{jobLocation}}',
      hourlyWage: 'Job hourly wage: {{hourlyWage}}',
      chooseOrCreate: 'Choose an existing role or create new',
      create: 'Create new role',
      expectedWorkingHours: 'Expected weekly hours',
      helperText1: 'Please set the average amount of time the student will work',
      helperText2:
        'These numbers are calculated based on the weekly working hours and hourly wage in case the student works 4 weeks a month.',
      helperText3:
        'You can see the workers you have already worked with by pressing the button below. If you would like to invite a new worker, please click on the add new button.',
      helperText4: 'Min. weekly hours is 1 and max is 48',
      contactPerson: 'Contact person name',
      instructions: 'First day instructions',
      recruitmentType: 'Is recruitment needed?',
      notProvided: '<Not provided>',
      inviteWorkersButton: 'Invite Students',
    },
    createRoleForm: {
      jobTitle: 'Role Title',
      jobDescription: 'Role Description',
      submitButtonLabel: 'Continue',
      companyProfile: 'What is the company profile?',
      county: 'County',
    },
    createRoleModal: {
      title: 'Do you want to create the below role?',
      roleTitle: 'Role title: {{roleTitle}}',
      roleDescription: 'Role description: {{roleDescription}}',
      roleLocation: 'Role location: {{roleLocation}}',
    },
    createJobOfferModal: {
      title: 'Select worker you want to invite',
      workerSelectTitle: 'Select student',
      jobSelectTitle: 'Select job',
      invite: 'Invite',
      noWorker: 'No workers invited',
      noJob: 'No works uploaded',
      createJobOffer: {
        success: 'Job offer created',
        inactiveJobSuccess: 'Job offer will be sent after activation',
        error: 'Failed to create job offer',
      },
    },
    editJobModal: {
      cancelTitle: 'This job cannot be edited',
      cancelDescription:
        'There are valid contracts associated with this role/job, you cannot edit it, alternatively you can cancel this role, create a new one and reinvite your workers',
    },
    GenerationModal: {
      title: 'We generated a post suggestion based on your job using AI!',
      reGeneration: 'Regenerate',
      copy: 'Copy',
      copied: 'Copied',
      error: 'Failed to copy the text',
      version: 'Version ',
      cancel: 'Close',
      text: {
        generating: 'Generating text, please wait..',
      },
      image: {
        generating: 'Generating image, please wait..',
        empty: 'Image not found',
        higherResolution: 'Click for higher resolution!',
      },
      generationSuccess: 'The Facebook post generation was successful',
      generationError: 'Error occured while generating the Facebook post',
    },
    inviteWorkersModal: {
      title: 'Select the students you want to invite to the job',
      resetSelectionButton: 'Clear selections',
      addNewStudentButton: 'Add new student',
      submitButton: 'Invite',
      addNewStudent: {
        title: 'Provide the name and phone number of the student you wish to invite',
      },
    },
    mobilePreview: {
      title: 'Job details',
      jobTitle: 'Job title',
      weeklyHours: 'hours/week',
      companyProfile: 'What does the company do?',
      hungarianSkills: 'Hungarian language',
      englishSkills: 'English language',
      workingHours: 'Working time',
      monthlyWage: 'Achievable monthly wage',
      haveQuestionsAboutJob: 'Want more information about this job?',
      haveQuestionsAboutApp: 'Do you have questions about the app?',
      openChat: 'Click here and chat with us',
      jobDescription: 'What will you do?',
      neededForJob: 'What is needed to fulfill the job?',
      longTermJob: 'Permanent job',
      shortTermJob: 'Temporary job',
      startNow: 'Start immediately',
      startLater: 'Start later',
      motorcycleDrivingLicense: 'Driving licence for motorcycle',
      carDrivingLicense: 'Driving licence for car',
    },
  },
  alerts: {
    phoneNumberValidate: {
      error: 'Invalid phone number',
    },
    smsSending: {
      error: 'Sms sending failed. Are You online?',
    },
    verificationCode: {
      error: 'Invalid password or email, try again!',
    },
    passwordReset: {
      title: 'Password Reminder',
      askPasswordReset: 'Send',
      passwordResetBody:
        'Forgot your password? Enter your email address and we will send you a new one.',
      placeholder: 'Email address',
      error: 'Error occurred while sending password reset',
      success: 'Password reset email sent successfully',
    },
    registration: {
      error: 'Registration failed, please try again!',
      managerWithThisEmailAlreadyExists: 'A manager with this email is already registered!',
    },
    getJobOffer: {
      error: 'Error occurred while downloading job offers',
    },
    acceptJobOffer: {
      error: 'Error occurred while accepting the job offer',
      success: 'You have successfully accepted the job offer',
    },
    declineJobOffer: {
      error: 'Error occurred while rejecting the job offer',
      success: 'You have successfully rejected your job offer',
    },
    calendar: {
      error: 'Error occurred while creating the calendar entry',
      success: 'We have successfully added the events to your calendar',
    },
    map: {
      error: 'We were unable to query the work location data.',
    },
    applyJob: {
      error: 'Error occurred while applying. Please try again',
      success: 'You have successfully applied for the job',
    },
    cancelJobApplication: {
      error: 'Error occurred while canceling the application.  Please try again',
      success: 'You have successfully canceled your application.',
    },
    getActiveJobs: {
      error: 'Error occurred while retrieving your current jobs',
    },
    getPendingJobApplications: {
      error: 'Error occurred while retrieving your job applications',
    },
    getJobConfirmations: {
      error: 'Failed to get job confirmations',
    },
    acceptJobConfirmations: {
      error: 'Job confirmation failed',
      success: 'Successfully confirmed {{hoursWorked}} hours',
    },
    getAccount: {
      error: 'Fetching financial data failed',
    },
    signContract: {
      error: 'Signing contract failed, pleasy try again later',
      success:
        'You have successfully signed the contract. We will send it in email for you shortly',
    },
    getMinWage: {
      error: 'Failed to get minimum wage amount',
    },
    getFeatureFlags: {
      error: 'Failed to get feature flags',
    },
  },
  alertPopup: {
    notSufficientData: {
      title: 'Incorrect data',
      helperText: 'Please upload your student ID',
      accept: 'Upload now',
      decline: 'Later',
    },
    cancelApplication: {
      title: 'Are you sure you want to cancel your application?',
      helperText: 'If you change your mind later, you will need to sign up again!',
      accept: 'Withdrawal',
      decline: 'Close',
    },
    notANumber: 'Must be a number',
  },
  validation: {
    required: 'Required',
    minLength: 'Must be at least {{number}} long',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone number',
    invalidFbGroupName: 'Do not use special characters',
    invalidFbGroupURL:
      'Provide the URL in the correct format, e.g.: https://www.facebook.com/groups/1234567891234567/',
    FbGroupURLAlreadyExists: 'A group with this URL already exists',
    FbGroupNameAlreadyExists: 'A group with this name already exists',
    minAndMaxlength: 'Must be at least {{min}} and at most {{max}} character long',
    minimum6Char: 'Minimum 6 characters',
    minimum4Char: 'Minimum 4 characters',
    minimum3Char: 'Minimum 3 characters',
    minimum11Char: 'Minimum 11 characters',
    minimum10Char: 'Minimum 10 characters',
    max4Char: 'Maximum 4 characters',
    onlyNumbers: 'Can only contain numbers',
    onlyNumbersVAT:
      'The VAT number must consist of at least 11 and at most 13 characters, in the following allowed formats: 12345678-9-12 or 12345678912.',
    passwordMatch: "Passwords don't match",
    passwordValidation:
      'Password must be between 6 to 20 characters which contain at least one numeric digit, one uppercase and one lowercase letter.',
  },
  loginScreen: {
    title: 'What is your phone number?',
    email: 'Email address',
    password: 'Password',
    supportText: 'Della Manager - for help, contact us at info@della.hu',
    phoneNumberCountryPrefix: 'Country prefix',
    helperText: 'Enter code sent to: {{phoneNumber}}',
    notReceivedText: 'Not received a code? - Resend',
    askPasswordReset: 'Jelszóemlékeztető küldés',
    linkToRegister: "Don't have an account?",
    signUp: 'Sign Up!',
    alreadyHaveAccount: 'Already have an account?',
  },
  homeScreen: {
    tabs: {
      financeTabTitle: 'Pénzügy',
      confirmationTabTitle: 'Igazolások',
      workersTabTitle: 'Diákok',
    },
  },
  registrationScreen: {
    mainText: 'Would you like to use Della?',
    helperText:
      'Please provide us with your business details to register. *(Please fill the company headquarters as address)',
    nameOfTheBusiness: 'Name of the business',
    zip: 'Zip Code',
    city: 'City',
    address: 'Address',
    country: 'Country',
    email: 'E-mail',
    vatNumber: 'VAT number',
    password: 'Password',
    phoneNumber: 'Phone Number',
    registrationNumber: 'Company registration number',
    organizationType: 'Organization type',
    organizationCompany: 'Company',
    organizationStudentOrg: 'Student Organization',
    representative: 'Company representative',
    button: 'Register',
    confirmDetails: 'Confirm details',
    confirmHelperText: 'Please check if your information is correct',
    confirm: 'Confirm',
    confirmPassword: 'Confirm password',
    edit: 'Edit',
    registerStudentOrg: {
      label1: 'I would like to register as a Student Cooperative',
    },
    readAndAcceptTOS: {
      label1: 'I have read and understood the <a>terms and conditions</a>',
      error: {
        required: 'You must accept TOS',
      },
    },
    readAndAcceptPrivacy: {
      label1:
        'I have read and accept the related <a>privacy policies</a>, and consent to the handling and storage of the provided data in accordance with these policies',
      error: {
        required: 'You must accept the Privacy Policy',
      },
    },
  },
  workersScreen: {
    worker: 'Worker',
    phone: 'Phone',
    status: 'Status',
    job: 'Job(s)',
    actions: 'Actions',
    preferredLocations: 'Preferred locations',
    noLink: 'Not available',
    inviteWorkers: 'Invite worker',
    more: 'more',
    chooseJob: 'Choose job',
    inviteToJob: 'Invite to job',
    confirmJob: 'Please confirm which job you would like to invite the students to',
    resetSelection: 'Clear selections',
    interview: {
      label: 'Interjú',
      options: {
        true: 'Van interjú',
        false: 'Nincs interjú',
      },
    },
    inviteWorkersForm: {
      phoneNumber: 'Phone number',
      name: 'Name',
      addStudent: 'Add student',
      cancel: 'Cancel',
      success: 'Worker has been added successfully',
      error: 'There was an error while inviting worker',
      confirmTitle: 'Confirm',
      confirmText: 'You are about to invite a student with the {{phoneNumber}} phone number',
    },
    invitedWorkerList: {
      invitedWorkerList: 'Invited worker list',
      emptyMessage: 'There are no invited workers yet',
    },
    availableWorkerList: {
      availableWorkerList: 'Available worker list',
      emptyMessage: 'There are no available workers',
    },
    alerts: {
      createOffer: {
        success: 'Job offer(s) created successfully',
        error: 'There was an error while creating job offer(s)',
      },
      workers: {
        error: 'There was an error while fetching workers',
      },
    },
  },
  supportScreen: {
    headerTitle: 'Support',
    helperText: 'If you have any questions feel free to contact us at info@della.hu',
    createMock: 'Create or clear mockdata',
    createMockDataButton: 'Create mockdata',
    clearMockDataButton: 'Clear all account data & logout',
    mockDataCreationSuccess: 'Mock data creation was success',
    mockdataCreationFailed: 'Mock data creation was FAILED',
    mockdataCleanFailed: 'Mock data clear was FAILED',
    mockDataClearSuccess: 'Mock data clear was success',
  },
  notificationScreen: {
    headerTitle: 'Notifications',
    noNotification: '(Your notification list is empty.)',
  },
  confirmationScreen: {
    title: 'Confirmations',
    approved: 'Approved',
    noConfirmation: 'You do not have pending confirmations.',
    tableHeader: {
      job: 'Job',
      worker: 'Worker',
      date: 'Date',
      workerAccepted: 'Worker approval',
      wage: 'Hourly rate (net)',
      hours: 'Hours',
      wageSum: 'Netto bér össz.',
      actions: 'Actions',
    },
    confirmationCard: {
      role: 'Role: ',
      workerName: 'Worker name: ',
      location: 'Job location: ',
      jobStarted: 'Job started: ',
      hoursWorked: 'Hours worked',
      accept: 'Accept',
      workerConfirmed: 'Worker already confirmed {{hoursWorked}}',
      workerNotConfirmed: 'Worker has not yet confirmet',
      managerConfirmed: '{{name}} has confirmed {{hoursWorked}} hours',
      managerNotConfirmed: "Manager hasn't confirmed the hours for the worker yet",
      status: 'The student receives {{wage}} HUF (Net) for working {{workingHours}} hours',
    },
    emptyList: '(You have no panding confirmation)',
  },
  financeScreen: {
    account: 'Account',
    totalTransactions: 'Total transactions: {{transactionCount}}',
    companyBalance: '{{balance}}',
    transactionList: 'Latest History',
    transactionDetails: 'Transaction details',
    transactionAmount: '{{amount}} HUF',
    transactionDate: '{{date}}',
    balanceAllHistory: 'All History',
    balanceShowLess: 'Show less',
    taxAlert: '* The amount shown is a net amount, for which we charge 27% VAT.',
    youHaveNoTransaction: '(You have no transactions)',
  },
  profileScreen: {
    userName: 'Manager Full Name:',
    userEmail: 'Email:',
    userPhoneNumber: 'Phone Number:',
    userNationality: 'Nationality:',
    companyName: 'Company:',
    companyPostCode: 'Post Code:',
    companyCity: 'Name of public area:',
    companyAddressLine1: 'Address:',
    companyCountry: 'Country:',
    companyEmail: 'E-mail of company:',
    companyVatNumber: 'VAT Number:',
    companyNumber: 'Company registration number:',
    info: 'Profile information',
  },
  workerProfile: {
    birthDay: 'Date of birth',
    hasPaidStudentOrg: 'Has valid membership at student organization',
    mothersName: 'Mothers name',
    socialSecurityNumber: 'Social Security Number',
    status: 'Status',
    studentIdNumber: 'Student ID Number',
    taxNumber: 'Tax Number',
    resend: 'Resend invite',
    nationality: 'Nationality',
    address: 'Address',
    gender: 'Gender',
    interview: {
      label: 'Video interview',
      noInterviewLabel: 'This worker currently has no video interview',
      defaultInterviewLabel: 'Default interview',
    },
    info: 'Worker information',
    actions: 'Actions',
    documents: {
      noContent: 'No documents available',
      documents: {
        title: 'Documents',
        error: 'Failed to retrieve documents',
      },
      contracts: {
        title: 'Contracts',
        error: 'Failed to retrieve contracts',
      },
      uploadDate: 'Upload Date',
      generationDate: 'Generation Date',
      view: 'View',
      notAvailable: 'Not Available',
      studentId: 'Student ID',
      studentStatus: 'Student Status',
      doctorsPaper: 'Medical Certificate',
    },
  },
  notInvitedScreen: {
    helperText: 'Thank you for the registration, we will invite zou soon.',
    description:
      'Della platform now working in Beta-version, but do not worry. We will invite you as soon as possible.',
  },
  workerCard: {
    date: 'Job offer sent: {{date}}',
    cancelWorker: 'Cancel Worker',
    profile: 'Profile',
    jobOfferSent: 'Job offer sent',
    documentReview: 'Documents under review',
    active: 'Active',
    inActive: 'Inactive',
    newApplicant: 'New applicant',
    more: 'more',
  },
  workersPage: {
    actions: {
      resendInvite: {
        title: 'Resend Invite',
        success: 'Invite successfully resent',
        error: 'An error occurred while resending the invite',
      },
      handleApplication: {
        title: {
          accept: 'Accept Application',
          decline: 'Decline Application',
        },
        subtitle: {
          accept: 'Accept {{name}}’s application',
          decline: 'Decline {{name}}’s application',
        },
        applicationsCount: 'Applications count: {{count}}',
        success: 'The worker application has been successfully processed',
        error: 'Failed to process worker application',
      },
      removeWorkerFromCompany: {
        title: 'Remove Worker from Company',
        success: 'The worker has been successfully removed from the company',
        error: 'An error occurred while removing the worker from the company',
        confirm: {
          title: 'Are you sure you want to remove the worker from the company?',
          bodyText: "With this you remove the worker's job offers as well ({{offerCount}})",
        },
      },
      terminateWorker: {
        title: 'Terminate Worker from Job',
        subtitle: 'Terminate {{name}} from work',
        activeJobsCount: 'Active jobs count: {{count}}',
        success: 'The worker has been successfully terminated from the job',
        error: 'An error occurred while terminating the worker from the job',
      },
      archiveWorker: {
        title: 'Archive Worker',
        success: 'The worker has been successfully archived',
        error: 'An error occurred while archiving the worker',
      },
    },
    status: {
      newApplication: 'New application',
      pendingOffer: 'Job offer sent',
      active: 'Active',
      inActive: 'Inactive',
      underReview: 'Documents under review',
    },
  },
  facebookPost: {
    scheduling: {
      alerts: {
        generatePost: {
          success: 'The post was successfully generated',
          error: 'An error occurred while generating the post',
        },
        getScheduledPosts: {
          success: 'Scheduled posts were successfully fetched',
          error: 'An error occurred while fetching scheduled posts',
        },
        schedulePost: {
          success: 'The post was successfully scheduled',
          error: 'An error occurred while scheduling the post',
        },
        updateScheduledPost: {
          success: 'The scheduled post was successfully updated',
          error: 'An error occurred while updating the scheduled post',
        },
        updatePost: {
          success: 'The post was successfully updated',
          error: 'An error occurred while updating the post',
        },
        facebookAuth: {
          success: 'Facebook login was successful',
          error: 'An error occurred during Facebook login',
        },
        checkConnectedPages: {
          error: 'An error occurred while checking the connected Facebook pages',
        },
        getFacebookGroups: {
          error: 'An error occurred while fetching Facebook groups',
        },
        addFacebookGroup: {
          success: 'The Facebook group has been successfully added',
          error: 'An error occurred while adding the Facebook group',
        },
      },
      thankYouPage: {
        thankYou: 'Thank you!',
        postUnderApproval: 'Your post is under approval.',
        postWithoutApproval: 'Would you like to be able to post without approval?',
        contactDella: 'Please reach out to the Della staff to enable automatic approval.',
      },
    },
  },
  facebookAuth: {
    loggedIn: 'Logged in',
  },
  photoUpload: {
    uploadButton: 'Upload Image',
    alerts: {
      fileSizeTooLarge: 'The image you are trying to upload exceeds the allowed size of 5 MB',
      incorrectFileType: 'Only JPG, JPEG, and PNG formats are supported',
    },
  },
  facebookAI: {
    addGroupModal: {
      title: 'Enter the name and URL of the group you want to add!',
      name: 'Name',
      url: 'URL',
      urlPlaceholder: 'https://www.facebook.com/groups/…',
      namePlaceholder: 'Group name',
      action: {
        confirmCloseTitle: 'Are you sure you want to exit?',
        confirmCloseText: 'The Facebook group will not be saved and the data will be lost.',
      },
    },
  },
  redirect: {
    error: 'An error occured while redirecting to another page',
  },
  genericTable: {
    resetFilters: 'Reset',
    pagination: {
      entriesInfo:
        'Filtered: {{filteredRowCount}} • Total: {{totalRowCount}}\nShowing: {{entriesStart}}-{{entriesEnd}} • Page: {{currentPage}} / {{totalPageCount}}',
      selectedRows: 'Number of selected: {{selectedRowCount}}',
    },
  },
};
